const state = () => ({
  supplier:null,
  suppliers:[],
  upload_dialog:false,
  attibutes:[],
  uploadpage:"brand",
  suppliers_renewed:false,
  createsupplierbackhistoryobj:{item:null,id:null},
});
const getters = {
  supplier(state){
    return state.supplier
  },
  suppliers(state){
    return state.suppliers
  },
  upload_dialog(state){
    return state.upload_dialog
  },
  attibutes(state){
    return state.attibutes
  },
  uploadpage(state){
    return state.uploadpage
  },
  suppliers_renewed(state){
    return state.suppliers_renewed
  },
  createsupplierbackhistoryobj(state){
    return state.createsupplierbackhistoryobj
  },
};
const  mutations =  {
  SET_SUPPLIER(state,data){
    state.supplier = data
  },
  SET_SUPPLIERS(state,data){
    state.suppliers = data
  },
  SET_UPLOAD_DIALOG(state,data){
    state.upload_dialog = data
  },
  SET_ATTRIBUTES(state,data){
    state.attibutes = data
  },
  SET_UPLOADPAGE(state,data){
    state.uploadpage = data
  },
  SET_SUPPLIERS_RENEWED(state,data){
    state.suppliers_renewed = data
  },
  SET_SUPPLIER_HISTORY_OBJ(state,data){
    state.createsupplierbackhistoryobj = data
  },
};
const actions =  {
  setSupplier({commit},data)  {
    commit("SET_SUPPLIER",data)
  },
  setSuppliers({commit},data)  {
    commit("SET_SUPPLIERS",data)
  },
  setUploadDialog({commit},data)  {
    commit("SET_UPLOAD_DIALOG",data)
  },
  setAttributes({commit},data)  {
    commit("SET_ATTRIBUTES",data)
  },
  setUploadPage({commit},data)  {
    commit("SET_UPLOADPAGE",data)
  },
  setSuppliersRenewed({commit},data)  {
    commit("SET_SUPPLIERS_RENEWED",data)
  },
  setSupplierHistoryObj({commit},data)  {
    commit("SET_SUPPLIER_HISTORY_OBJ",data)
  },
}

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};

